import { Module } from 'vuex'
import { RootState } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { usePremiumHttp } from '@/core/api/premium'
import { PremiumUserFeedback, PremiumUserFeedbackPayload } from '@/core/models/premium-user-feedback'

export type PremiumUserFeedbackCollection = {
    data: Array<PremiumUserFeedback>,
    meta?: MetaPayload,
}

const state: PremiumUserFeedbackCollection = {
    data: [],
    meta: <any>{},
}

export const premiumUserFeedbackCollection: Module<PremiumUserFeedbackCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: PremiumUserFeedbackCollection, payload: any) => {
            state.data = []
            ;(payload.data || []).forEach((item: PremiumUserFeedbackPayload) => {
                state.data.push(new PremiumUserFeedback(item))
            })
            state.meta = payload.meta
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                usePremiumHttp()
                    .getUserFeedbacks(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: PremiumUserFeedbackCollection): PremiumUserFeedbackCollection => {
            return state
        },
    },
}
